<template>
  <div id="app">
    <link
        rel="stylesheet"
        type="text/css"
        :href="`https://${domain}/api/conference/eventInformation/${entity}/style.css`"
        media="all"
    />

    <ConferenceSchedule
        :entity="entity"
        :domain="domain"
        :program="program"
        add-top-menu-class="top-16"
        :selected-date="selectedDate"
        :auto-scroll="autoScroll"
    />
    <GlobalLoader/>
  </div>
</template>

<script setup>
import {ref, reactive, computed, onBeforeMount, onMounted} from 'vue'
import axios from 'axios'
import ConferenceSchedule from './Components/ConferenceSchedule.vue'
import GlobalLoader from '../../Components/Global-Loader.vue'
import { useStore } from 'vuex'

// props
const props = defineProps({
  id: {type: String, default: null},
  domain: {type: String, default: null},
  name: {type: String, default: null},
  autoScroll: {type: Boolean, default: false},
  hash: {type: String, default: null},
  entity: {type: String, default: null},
})

// alias global store
const store = useStore()

// reactive state
const program = reactive({})
const selectedDate = ref(null)

// computed: replicates your dateMenu logic
const dateMenu = computed(() => {
  if (!program.dates || !program.eventItems) return {}
  const result = {}
  for (const key in program.dates) {
    if (!program.eventItems[key]) continue
    let includeDay = false
    for (const idx in program.dates[key]) {
      const roomId = program.dates[key][idx].event_room_id
      if (program.rooms[roomId] && !program.rooms[roomId].hidden) {
        includeDay = true
        break
      }
    }
    if (includeDay) result[key] = program.dates[key]
  }
  return result
})

// helper to parse dates
function getDateObject(dateString) {
  return window.moment(dateString, 'YYYY-MM-DD')
}

// fetch & process schedule
async function getConferenceSchedule() {
  window.conferenceBus.globalLoading = true
  let lang = 'de'
  if (window.appSettings?.appLanguage) lang = window.appSettings.appLanguage
  window.widgetDomain = props.domain

  try {
    const {data} = await axios.get(
        `https://${props.domain}/api/customer/widget/${props.id}/${props.hash}?lang=${lang}`
    )
    // flatten eventItems
    const allItems = []
    _.forEach(data.eventItems, day =>
        _.forEach(day, batch =>
            _.forEach(batch, ev => allItems.push(ev))
        )
    )
    data.eventItems_all = allItems

    // merge into reactive state
    Object.assign(program, data)

    // commit to store
    store.commit('setProgram', data)
    store.commit('setEventItems', allItems)
  } catch (err) {
    console.error(err)
    setTimeout(getConferenceSchedule, 8000)
  } finally {
    window.conferenceBus.globalLoading = false
  }
}

// set up global bus before mount
onBeforeMount(() => {
  window.conferenceBus = {globalLoading: false}
})

// mount logic: inject MathJax, fetch data, typeset
onMounted(() => {
  const script = document.createElement('script')
  script.src =
      '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_CHTML'
  document.head.appendChild(script)

  getConferenceSchedule()

  // delay typesetting until MathJax loads
  setTimeout(() => {
    MathJax.Hub.Config({
      messageStyle: 'none',
      tex2jax: {
        inlineMath: [['$', '$'], ['\\(', '\\)']],
      },
    })
    MathJax.Hub.Queue(['Typeset', MathJax.Hub])
  }, 500)
})
</script>

<style scoped>
/* add any scoped styles here */
</style>
